define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/promise/all",
	"dojo/query",
	"csi/widget/CrossOut",
	"csi/heading/_base",
	"csi/heading/RefContainer",
	"csi/html",
	"csi/image/LightGalleryController",
	"csi/property/Widget",
	"csi/reflection",
	"csi/xml"
], function(array, declare, lang, domClass, domConstruct, all, query, crossOut, headingBase, RefContainer, html, LightGalleryController, Widget, reflection, xml) {

	const _ColorsRen = declare(RefContainer, {
		/**
		 * @override
		 */
		getReferencedNodes(ctx, h) {
			return ctx.view._colors;
		}
	});

	const _ImageController = declare(LightGalleryController, {
		/**
		 * @override
		 * If in switchboard, then notify view of selected image; otherwise, treat normally and show viewable image
		 */
		process() {
			if (this.widget.clickImage(this.m_element, this.getNode())) {
				this.postProcess();
			} else {
				LightGalleryController.prototype.process.call(this);
			}
		}
	});

	return declare(Widget, {
		_actionControllers: {
			FullSizeImage: _ImageController
		},

		// String: all images other than main property image are thumbnails
		imageSize: reflection.IMAGE_SIZE_SMALLEST,

		// String: ability to set initial color selected other than first in list
		urlFirstColor: null,

		// Boolean: indicates if currently displaying color images rather than style images
		_bColorImages: false,

		// {String:Heading}: map of headings to use when colors exist or not
		_colorHeadings: null,

		// Node[]: array of available colors
		_colors: null,

		// Node: SMProductGroup in context
		_productGroup: null,

		// {String:Heading}: map of product headings by key
		_productHeadings: null,

		// String: currently selected color
		_urlColor: null,

		// String: currently highlighted color
		_urlColorHighlight: null,

		clickColor: function(/*DOMNode*/refNode, /*Node*/node) {
			// summary: if color is highlighted, then process; otherwise return false to view image
			if (node.$URL == this._urlColor) {
				return true;
			}

			if (this._urlColorHighlight) {
				this.unselectAll(this.dimsNode);
				this.select(refNode, true);
				this._refreshColor(node.$URL);
				return true;
			}

			return false;
		},

		clickImage: function(/*DOMNode*/refNode, /*Node*/node) {
			// summary: if not in catalog view, then just handle color selection
			return this.clickColor(refNode, node);
		},

		getCatalogColors: function(/*Node[]*/colors) {
			// summary: filter list of colors ready to display in catalog
			return colors;
		},

		getColorImageNode: function(/*Node*/color) {
			// summary: return node for color that contains images
			return color;
		},

		onCatalogHeadings: function(/*Heading[]*/h) {
			// summary: populate _productHeadings and _colorHeadings
		},

		onRenderCatalogProduct: function(/*Context*/ctx, /*Deferred[]*/dfds) {
			// summary: render product-specific attributes
		},

		onRenderCatalogColor: function() {
			// summary: render color-specific attributes
		},

		_onColorImages: function() {
			// summary: prepare color images for highlighting and select first color
			query("img", this.dimsNode).forEach(function(img) {
				this.enableHighlighting(img);

				if (domClass.contains(img.parentNode, "csiCatalogSoldOut")) {
					var w = new crossOut();
					domConstruct.place(w.domNode, img.parentNode, "first");
				}

				if (this._urlColor == html.getElementContext(img, true)) {
					this.select(img, true);
				}
			}, this);
		},

		_onHighlightOn: function(/*Event*/e) {
			// summary: onmouseover callback for highlighting
			this.inherited(arguments);

			var ctx = this.getContext();
			ctx.readNodeContext(e.currentTarget);
			this._refreshColor(ctx.getNodeURL(), true);
		},

		_onHighlightOff: function(/*Event*/e) {
			// summary: onmouseout callback for highlighting
			this.inherited(arguments);
			this._refreshColor(null, true);
		},

		_refreshColor: function(/*String*/url, /*Boolean*/bHighlight) {
			// summary: refresh color information
			var urlOld = this._urlColorHighlight || this._urlColor;

			if (bHighlight) {
				this._urlColorHighlight = url;
			} else {
				this._urlColor = url;
				this._urlColorHighlight = null;
			}

			var urlNew = this._urlColorHighlight || this._urlColor;
			if (urlOld != urlNew) {
				if (this._timer) {
					clearTimeout(this._timer);
					this._timer = null;
				}

				if (url) {
					// if switching to new color, then render changes immediately
					this.onRenderCatalogColor();
					this.refreshImages();
				} else {
					// if unhighlighting, then wait to switch back to selected color until sure they are not going to highlight another
					this._timer = setTimeout(lang.hitch(this, function() {
						this.onRenderCatalogColor();
						this.refreshImages();
					}), 100);
				}
			}
		},

		// Property view overrides

		getImageContainer: function() {
			// summary: return node containing images
			return this._getColorImageNode() || this.inherited(arguments);
		},

		_resolveView: function() {
			// summary: determine if product group in context and build map of headings for quick access
			var smpg = this.viewParent && this.viewParent.getViewNode();

			// use ShowPromos attribute as test to see if it is indeed a SMProductGroup (rather than testing for SalesCollection or SalesLook)
			if (smpg && smpg.ShowPromos == null) {
				smpg = null;
			}

			this._productGroup = smpg;
			this.inherited(arguments);

			// build lookup maps of headings to simplify rendering
			this.onCatalogHeadings(this.defView.getHeadings());

			// assign special renderer for color matrix to only go through available colors
			this._productHeadings.colors.classRenderer = _ColorsRen;
		},

		_buildColumns: function(/*Context*/ctx) {
			// summary: build attribute groups for Brands, Features, Looks, Summary, Details, and Documents
			var h = this._productHeadings;
			var dfds = [];

			headingBase.clearHtml(this.nameNode);
			headingBase.toHtml(ctx, h.name, this.nameNode);

			headingBase.clearHtml(this.codeNode);
			headingBase.toHtml(ctx, h.code, this.codeNode);

			// render product attributes
			this.onRenderCatalogProduct(ctx, dfds);

			// render color attributes
			this.onRenderCatalogColor();

			// after all images loaded, add interactivity to color images
			var dfd = all(dfds);

			if (this._urlColor) {
				dfd.then(lang.hitch(this, this._onColorImages));
			}

			return dfd;
		},

		_buildView: function() {
			// summary: select first color of product that is available
			var product = this.getViewNode();
			var colors = this.getCatalogColors(this.cacheView.getNodes(product.Colors));

			if (colors.length) {
				this._colors = xml.sortNodes(colors);

				if (this.urlFirstColor && array.some(colors, function(c) {return c.$URL == this.urlFirstColor;}, this)) {
					this._urlColor = this.urlFirstColor;
				} else {
					this._urlColor = this._colors[0].$URL;
				}
			} else {
				this._colors = this._urlColor = null;
			}

			this.urlFirstColor = this._urlColorHighlight = null;
			this.inherited(arguments);
		},

		_getColorImageNode: function() {
			// summary: return color node if it has images
			var color = this.cacheView.getNode(this._urlColorHighlight || this._urlColor);
			if (color) {
				color = this.getColorImageNode(color);

				if (xml.isValidURL(color.Images[reflection.DEFAULT_IMAGE_LABEL])) {
					return color;
				}
			}

			return null;
		}
	});
});